
import { Usr_Log } from 'src/app/shared/models/usr_log';
import { UDF } from 'src/app/shared/models/domain/udf';
import { NavigateUtil } from 'src/app/shared/utils/navigate.util';
import { CommonEnums } from 'src/app/shared/common.enums';
import { UDFGridObject } from 'src/app/shared/models/beans/udfgridobject';
import { Util } from 'src/app/shared/utils/util';
import { DatabaseWrappersFactory } from 'src/app/shared/databases/database.wrappers.factory';

export class UDFUtil {
    private static instance: UDFUtil;

    static getInstance() {
        if (!UDFUtil.instance) {
            UDFUtil.instance = new UDFUtil();
        }

        return UDFUtil.instance;
    }

    /**
     * UDFUtil is a singleton class, so use UDFUtil.getInstance() method instead of creating new UDFUtil().
     */
    private constructor() {

    }

    getUsr_Log(uDF: UDF): Usr_Log {
        let usr_Log: Usr_Log = new Usr_Log();

        usr_Log.obj_Cd = CommonEnums.codes.UDF;
        usr_Log.obj_Id = uDF.usr_Def_Fun.udf_Id;
        usr_Log.nm = uDF.usr_Def_Fun.nm;
        usr_Log.objectName = "UDF";
        usr_Log.imageUrl = 'assets/' + uDF.imageUrl.slice(4, uDF.imageUrl.length);
        usr_Log.valid_Cd = uDF.usr_Def_Fun.valid_Cd;
        usr_Log.valid_Msg = Util.getInstance().getValid_Msg(uDF.usr_Def_Fun.valid_Cd);
        usr_Log.mode_Ind = uDF.mode_Ind;
        usr_Log.change_Ind = uDF.change_Ind;
        usr_Log.fldr_Id = uDF.fldr_Id;

        usr_Log.url = NavigateUtil.getInstance()
            .getUDFUrl(uDF.usr_Def_Fun.udf_Id, uDF.fldr_Id, '');
            
        return usr_Log;
    }

    updateGridObject(uDFGridObject: UDFGridObject, uDf: UDF): void {
        if (uDFGridObject.obj_Id != uDf.usr_Def_Fun.udf_Id) return;

        uDFGridObject.nm = uDf.usr_Def_Fun.nm;
        uDFGridObject.aliasNm = uDf.usr_Def_Fun.aliasNm;
        uDFGridObject.valid_Cd = uDf.usr_Def_Fun.valid_Cd;
        uDFGridObject.change_Ind = uDf.change_Ind;
        uDFGridObject.recExists = uDf.isRecExists;
        uDFGridObject.updateBy = uDf.usr_Def_Fun.updateBy;
        uDFGridObject.updateDt = uDf.usr_Def_Fun.updateDt;
        uDFGridObject.imageUrl = uDf.imageUrl;
        let databaseWrapper =  DatabaseWrappersFactory.getInstance().getDatabaseWrapper(uDf.usr_Def_Fun.dbtyp_Id);
        uDFGridObject.dbTyp_Nm = databaseWrapper.name;
    }

    updateUsr_Log(usr_Log: Usr_Log, uDF: UDF): void {
        if (usr_Log.obj_Id != uDF.usr_Def_Fun.udf_Id) return;

        usr_Log.nm = uDF.usr_Def_Fun.nm;
        usr_Log.objectName = "UDF";
        usr_Log.valid_Cd = uDF.usr_Def_Fun.valid_Cd;
        usr_Log.valid_Msg = Util.getInstance().getValid_Msg(uDF.usr_Def_Fun.valid_Cd);
        let imageUrl = 'assets/' + uDF.imageUrl.slice(4, uDF.imageUrl.length)
        usr_Log.imageUrl = imageUrl;
        usr_Log.mode_Ind = uDF.mode_Ind;
        usr_Log.change_Ind = uDF.change_Ind;
    }

    copy(udfs: Array<UDF>): Array<UDF> {
        let udfsTmp: Array<UDF> = new Array<UDF>();

        for (let i: number = 0; i < udfs.length; i++) {
            let udf: UDF = udfs[i] as UDF;
            udfsTmp.push(udf.copy())
        }
        return udfsTmp;
    }

    copyFrom(udfs: Array<UDF>, udfsTmp: Array<UDF>): void {
        let udfsMap: Map<number, UDF> = new Map();

        let udfsLength: number = udfs.length;
        for (let i: number = 0; i < udfsLength; i++) {
            udfsMap.set(udfs[i].usr_Def_Fun.udf_Id, udfs[i]);
        }

        udfs.splice(0, udfs.length);

        let udfsTmpLength: number = udfsTmp.length;
        for (let i: number = 0; i < udfsTmpLength; i++) {
            let udfTmp: UDF = udfsTmp[i] as UDF;
            let udf: UDF = udfsMap.get(udfTmp.usr_Def_Fun.udf_Id);
            if (udf) {
                udf.copyFrom(udfTmp);
            } else {
                udf = UDF.parse(udfTmp);
            }

            udfs.push(udf);
        }
    }

    toString(udfs: Array<UDF>): string {
        let str: string = '';

        str += 'udfs length: ' + udfs.length + ' ';

        for (let i: number = 0; i < udfs.length; i++) {
            let udf: UDF = udfs[i] as UDF;
            str += udf.toString();
        }

        return str;
    }

}